import React, { FC } from 'react'
import { motion } from 'framer-motion'

interface IMorphingHamburgerIconProps {
  className?: string
  color?: string
  isHovered?: boolean
  isOpen?: boolean
}

export const MorphingHamburgerIcon: FC<IMorphingHamburgerIconProps> = ({
  className = '',
  color = 'currentColor',
  isHovered,
  isOpen = false,
}) => {
  // Top line: initial (5->12 at y=7), hover (5->19 at y=7), open (diagonal \ from 6,6 to 18,18)
  const topVariants = {
    initial: {
      d: 'M 5 7 L 12 7',
      transition: { duration: 0.3, ease: 'easeOut' },
    },
    hover: {
      d: 'M 5 7 L 19 7',
      transition: { duration: 0.3, ease: 'easeOut' },
    },
    open: {
      d: 'M 6 6 L 18 18',
      transition: { duration: 0.3, ease: 'easeOut' },
    },
  }

  // Center line: initial/hover (5->19 at y=12, opacity 1), open (opacity 0)
  const centerVariants = {
    initial: {
      d: 'M 5 12 L 19 12',
      opacity: 1,
      transition: { duration: 0.3, ease: 'easeOut' },
    },
    hover: {
      d: 'M 5 12 L 19 12',
      opacity: 1,
      transition: { duration: 0.3, ease: 'easeOut' },
    },
    open: {
      d: 'M 12 12 L 12 12',
      opacity: 0,
      transition: { duration: 0.2, ease: 'easeOut' },
    },
  }

  // Bottom line: initial (12->19 at y=17), hover (5->19 at y=17), open (diagonal / from 6,18 to 18,6)
  const bottomVariants = {
    initial: {
      d: 'M 12 17 L 19 17',
      transition: { duration: 0.3, ease: 'easeOut' },
    },
    hover: {
      d: 'M 5 17 L 19 17',
      transition: { duration: 0.3, ease: 'easeOut' },
    },
    open: {
      d: 'M 6 18 L 18 6',
      transition: { duration: 0.3, ease: 'easeOut' },
    },
  }

  const animationState = isOpen
    ? 'open'
    : isHovered !== undefined
    ? isHovered
      ? 'hover'
      : 'initial'
    : undefined

  return (
    <motion.svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      initial="initial"
      animate={animationState}
      whileHover={!isOpen && isHovered === undefined ? 'hover' : undefined}
      className={`w-6 h-6 overflow-visible ${className}`}
    >
      <motion.path
        variants={topVariants}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <motion.path
        variants={centerVariants}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <motion.path
        variants={bottomVariants}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </motion.svg>
  )
}

export default MorphingHamburgerIcon
